<template>
    <div class="flex-none w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/6 p-2">
        <div class="border rounded p-4 relative pb-8 h-full">
            <div class="text-grey-darkest font-semibold text-sm uppercase flex mb-4" v-if="category.name != ''">
                <span class="flex-1">{{category.name}}</span>
                <button class="text-brand flex-none self-start" @click.prevent="edit(category)"><i class="fa fa-edit"></i></button>
            </div>

            <tags v-model="category.tags" :category-id="category.id"></tags>
            
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import Tags from "./Tags";

export default {
  components: {
    draggable,
    Tags
  },

  props: ["category"],

  data() {
    return {};
  },

  methods: {
    edit(category) {
      this.$emit("edit-category-tags", this.category);
    }
  }
};
</script>

<style>
</style>
